import { useContractWrite, usePrepareContractWrite } from 'wagmi';

import { peacefallABI } from '~/abis/peacefall';
import { PEACEFALL_ADDRESS, POTION_ADDRESS } from '~/constants';

export const useSetApproval = () => {
  const { config } = usePrepareContractWrite({
    address: PEACEFALL_ADDRESS,
    abi: peacefallABI,
    functionName: 'setApprovalForAll',
    args: [POTION_ADDRESS, true],
  });
  return useContractWrite(config);
};
